import React from 'react'
import s from './FPS.less'

function now() {
  return (performance || Date)['now']()
}

class FPS extends React.Component {
  constructor(props) {
    super(props)
    this.state = { ...props, fps: '', stop: false }
  }

  componentDidMount() {
    this.compute()
  }

  componentWillUnmount() {
    this.setState({ stop: true })
    clearInterval(this._interval)
  }

  compute() {
    this.count = 0
    this.then = now()

    function count() {
      if (this.state.stop) return
      this.count++

      requestAnimationFrame(count.bind(this))
    }

    requestAnimationFrame(count.bind(this))

    this._interval = setInterval(this.updateFpsCount.bind(this), 600)
  }

  updateFpsCount() {
    const deltaTime = now() - this.then
    const fps = this.count / (deltaTime * 0.001)

    this.setState({ fps: fps.toFixed(1) + ' fps' })

    this.then = now()
    this.count = 0
  }

  render() {
    return <div className={s.main}>{this.state.fps}</div>
  }
}

export default FPS
